import {
    PaymentMethod,
    OrderAddress as OrderAddressFromModel,
    OtherAddress as OtherAddressFromModel,
} from "../models/Order";

// Since these never change, we'll just hard code them here
export const COUNTRIES: { [countryId: number]: string } = {};
export const STATES: { [countryId: number]: string } = {};

export const PaymentMethodFriendlyName = (method: PaymentMethod | null) => {
    switch (method) {
        case PaymentMethod.CASH:
            return "Cash";
        case PaymentMethod.DEBIT:
            return "Debit";
        case PaymentMethod.CREDIT_MC:
            return "MasterCard";
        case PaymentMethod.CREDIT_VISA:
            return "Visa";
        case PaymentMethod.CREDIT_AMEX:
            return "American Express";
        case PaymentMethod.CREDIT_OTHER:
            return "Credit Card (Other)";
        case PaymentMethod.DEBIT_CREDIT:
            return "Debit/Credit";
        case PaymentMethod.CHEQUE:
            return "Cheque";
        case PaymentMethod.INVOICE:
            return "Invoice";
        case PaymentMethod.ELECTRONIC_PAYMENT:
            return "Electronic Payment";
        default:
            return "Unknown";
    }
};

export interface OrderRequest {
    cartKey: string;
    discountCode: string;
    sdaCode?: string;
    address: OrderAddress;
    shippingAddress?: OtherAddress;

    sanityCheck: SanityCheck;

    // Only one or the other
    squareOnlinePayment?: SquareOnlinePayment;
    ecommercePayment?: EcommercePayment;
    offlinePayment?: OfflinePayment;

    // Optional map of GA departments and their quantity that should be in the cart.
    // If specified, `sanityCheck.ticketIds` is ignored, but the expected totals must match.
    cartContents?: { [key: string]: number };

    metadata?: { [key: string]: string | undefined };

    ticketFields?: { [key: string]: any };

    orderFields?: {
        fieldId: number;
        value: any;
    }[];

    donations?: {
        [key: number]: number;
    };

    deliveryMethodId: number;
    customAmount?: number;
}

export interface SanityCheck {
    ticketIds: Array<number>;
    eventPackageStatusIds: Array<number>;
    expectedSubTotal: number;
    expectedTotal: number;
}

// Base everything off the version in the model; however,
// keep this separate in case there are any future differences
export interface OrderAddress extends OrderAddressFromModel {}

export interface OtherAddress extends OtherAddressFromModel {}

export interface EcommercePayment {
    discriminator: "ECOMMERCE";
    cardNum?: string;
    expiryMonth?: string;
    expiryYear?: string;
    nameOnCard?: string;
    cvv?: string;
    reCaptchaResponse?: string;
    acceptNonceValue?: string;
    acceptNonceDescriptor?: string;
    cardinalResponseToken?: string;
}

export interface SquareOnlinePayment {
    discriminator: "SQUARE_ECOMMERCE";
    squareNonce: string;
    verificationToken?: string;
    reCaptchaResponse?: string;
}

export interface OfflinePayment {
    discriminator: "OFFLINE";
    paymentMethod: PaymentMethod;
    squarePayment?: SquarePayment;
    squareDeviceId?: number;
}

export interface SquarePayment {
    clientTransactionId: string;
    serverTransactionId: string;
    requestMetadata: string;
}

export const IsEcommercePayment = (object: any): object is EcommercePayment => {
    return object.discriminator === "ECOMMERCE";
};

export const IsSquareEcommercePayment = (
    object: any,
): object is SquareOnlinePayment => {
    return object.discriminator === "SQUARE_ECOMMERCE";
};

export const IsOfflinePayment = (object: any): object is OfflinePayment => {
    return object.discriminator === "OFFLINE";
};

export interface SendOrderLinksRequest {
    email: string;
    reCaptchaResponse?: string;
}
